import React from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { ICampaignDeliverables } from '../../../../interfaces/campaign.interface';
import { DeliverableTask, Platform } from '../../../../constants/campaign';

interface IProps {
    index: number;
    deliverable: ICampaignDeliverables;
}

const ViewSubDeliverable = ({ index, deliverable }: IProps) => {
    return (
        <div className="tw-w-full tw-flex tw-items-start tw-gap-x-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-font-bold tw-text-base tw-p-3"></span>
            <div className="tw-ml-[60px] md:tw-ml-[128px] tw-grow tw-flex tw-items-center tw-justify-between tw-gap-x-2 tw-py-2 tw-px-4 tw-border tw-rounded-md tw-border-gray-250">
                <div className="tw-grow tw-flex tw-items-center tw-gap-x-2">
                    <div className="tw-py-1 tw-px-3 tw-rounded-md tw-bg-gray-100">
                        {deliverable.task}
                    </div>

                    {deliverable.task === DeliverableTask.RESIZE && (
                        <>
                            <p>to</p>
                            <div className="tw-py-1 tw-px-3 tw-rounded-md tw-bg-gray-100">
                                {deliverable.platform}
                            </div>
                            {deliverable.platform === Platform.CUSTOM ? (
                                <>
                                    <div className="tw-flex tw-items-center gap-1">
                                        <div>{deliverable.height ? deliverable.height : 100}</div>
                                        <p>px</p>
                                    </div>
                                    <p>X</p>
                                    <div className="tw-flex tw-items-center gap-1">
                                        <div>{deliverable.width ? deliverable.width : 100}</div>
                                        <p>px</p>
                                    </div>
                                </>
                            ) : (
                                <div className="tw-py-1 tw-px-3 tw-rounded-md tw-bg-gray-100">
                                    {deliverable.asset_type}
                                </div>
                            )}
                        </>
                    )}
                    {deliverable.task === DeliverableTask.VARIANT && (
                        <>
                            <div>{deliverable.content}</div>
                        </>
                    )}
                </div>
            </div>
            <div className="tw-flex tw-items-center tw-jutify-center tw-w-[42px] tw-h-[42px]"></div>
        </div>
    );
};

export default ViewSubDeliverable;
